<div
  v-if="notProd()"
  :class="[$style.gridview, {[$style.isVisible]: isVisible()}]">
  <div
    v-if="isVisible()"
    :class="$style.grid"
    class="mt-grid contain">
    <div :class="$style.row" class="row">
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div>
      <div :class="$style.col" class="col is1">
        <div :class="$style.gridbox"></div>
      </div> 
    </div>
  </div>
  <button type="button" :class="[$style.gridviewToggle, {[$style.isActive]: isVisible()}]" @click="toogleGridview">
    <svg version="1.1" id="Ebene_2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    	 viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
    <g>
    	<g>
    		<path d="M14.1,16.4v4.5H3v-4.5H14.1 M15.1,15.4H2v6.5h13.1V15.4L15.1,15.4z"/>
    	</g>
    	<g>
    		<defs>
    			<path id="SVGID_1_" d="M14.1,24.5v4.2H3v-4.2H14.1 M15.1,23.5H2v6.2h13.1V23.5L15.1,23.5z"/>
    		</defs>
    		<use xlink:href="#SVGID_1_" style="overflow:visible;"/>
    		<clipPath id="SVGID_2_">
    			<use xlink:href="#SVGID_1_" style="overflow:visible;"/>
    		</clipPath>
    		<path clip-path="url(#SVGID_2_)" d="M2,23.5h13.1v6.2H2V23.5z"/>
    	</g>
    </g>
    <path d="M29,3.6v8.8H3V3.6H29 M30,2.6H2v10.8h28V2.6L30,2.6z"/>
    <g>
    	<defs>
    		<path id="SVGID_3_" d="M29,16.4v12.3H17.9V16.4H29 M30,15.4H16.9v14.3H30V15.4L30,15.4z"/>
    	</defs>
    	<use xlink:href="#SVGID_3_" style="overflow:visible;"/>
    	<clipPath id="SVGID_4_">
    		<use xlink:href="#SVGID_3_" style="overflow:visible;"/>
    	</clipPath>
    	<rect x="16.9" y="15.4" clip-path="url(#SVGID_4_)" width="13.1" height="14.3"/>
    </g>
    </svg>
  </button>
</div>